import { GET_METHOD } from "../../axiosMethod";
import { getHeaders } from "../../config";


export const getUserLocation = async (payload) => {
  try {
    const data = await GET_METHOD("location/user-locations",{
      headers: getHeaders(),
    });
    return data
  } catch (error) {
    return {
      data:error?.response?.data
    }
  }
};

